import {
	applyReportsFilter,
	focusReport,
	openReportsSection,
	openSensorModeSection,
} from './adapter';
import {
	openReportsCreateModal,
	openReportsDeleteModal,
	openReportsEditModal,
} from './modal';
import {mapReportsPrefill} from './prefill';
import {resolveReports} from './resolver';
import {serializeReportsContext} from './context';
import {
	highlightExistingAction,
	highlightFirstExistingControl,
} from '../../core/actionHighlighter';

/**
 * Open the Reports list and carry out a highlighted toolbar action.
 * @param {object} command experience command
 * @return {Promise<void>} completion
 */
async function openReportsInventory(command) {
	await openReportsSection();
	const target = command.params?.action_target;
	const activation = {
		activate: command.params?.action_activation === 'auto',
		commandId: command.command_id,
	};
	if (target === 'refresh' &&
		!highlightExistingAction(['Refresh'], [], activation)) {
		throw new Error('reports_refresh_unavailable');
	}
	if (target === 'bulk_select_delete' &&
		!highlightFirstExistingControl([
			'[role="grid"] [role="checkbox"]',
			'table thead input[type="checkbox"]',
		])) {
		throw new Error('reports_bulk_selection_unavailable');
	}
}

const reportsPlugin = {
	id: 'reports',
	version: 1,
	commandVersion: 1,
	resource: 'reports',
	operations: [
		'options',
		'view',
		'search',
		'create',
		'create_predefined',
		'edit',
		'delete',
		'download_row',
		'bulk_delete',
		'refresh',
	],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.reports': openReportsInventory,
	},
	resolvers: {
		report: resolveReports,
	},
	filters: {
		report: applyReportsFilter,
	},
	focusHandlers: {
		report: focusReport,
	},
	modals: {
		'reports.create': openReportsCreateModal,
		'reports.edit': openReportsEditModal,
		'reports.delete': openReportsDeleteModal,
	},
	prefillMappers: {
		'reports.create': mapReportsPrefill,
	},
	contextSerializers: {
		reports: serializeReportsContext,
	},
};

const sensorModePlugin = {
	id: 'sensor_mode',
	version: 1,
	commandVersion: 1,
	resource: 'sensor_mode',
	operations: ['options', 'view'],
	dependencies: {
		plugins: ['canvas.navigation', 'reports'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.sensor_mode': openSensorModeSection,
	},
};

export {sensorModePlugin};
export default reportsPlugin;
